import getApiClient from '@/plugins/api-client'

export default {
    load() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('home_photos')
            .then(result => {
                self.photos = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.newPhotos = []
                self.currentUploadingPhoto = 0
                self.processedPhotos = 0
                self.percent = 1
                self.uploading = false
            })
    },
    upload() {
        const self = this,
            api = getApiClient(self.$store),
            toUpload = self.newPhotos.length

        self.uploading = true
        let photo = self.newPhotos[self.currentUploadingPhoto]
        api.post('home_photos', {
            path: photo,
            position: self.photos.length + (self.currentUploadingPhoto + 1)
        }).finally(() => {
            self.processedPhotos++

            self.percent = Math.round((self.processedPhotos / toUpload) * 100)

            self.currentUploadingPhoto++
            if (self.currentUploadingPhoto < toUpload) {
                self.upload()
            }

            if (self.processedPhotos === toUpload) {
                self.load()
            }
        })
    },
    setImages(files) {
        const self = this

        self.newPhotos = []
        files.forEach(image => {
            let reader = new FileReader()
            reader.readAsDataURL(image)
            reader.onload = e => {
                self.newPhotos.push(e.target.result)
            }
        })
    },
    remove(photo, photoIndex) {
        const self = this,
            api = getApiClient(self.$store)

        api.delete(`/home_photos/${photo.id}`)
            .then(() => {
                self.$delete(self.photos, photoIndex)
            })
    },
    updatePhotoSorting() {
        const self = this,
            api = getApiClient(self.$store)

        let payload = {
            photos: []
        }

        self.photos.forEach((photo, index) => {
            photo.position = index

            payload.photos.push({
                id: photo.id,
                position: index
            })
        })

        self.sortingChanged = false

        api.post('home_photos/sort', payload)
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.load()
            })
    }
}
